// diagrammThema.ts — Farben, Popup und Muster für ECharts aus den me-design-Tokens (Plan P4, P6).
import { echartsThema } from "../me/index.js";
/** Zustandsfarben zusätzlich zu `echartsThema()` von me-design: Schlüssel → Token. */
const ZUSATZ = {
    ok: "--ok", warnung: "--warnung", fehler: "--fehler", aus: "--status-aus", flaeche: "--flaeche",
    linieStark: "--linie-stark", aktion: "--aktion", farbschema: "--farbschema", hover: "--hover",
};
/** Liest das Thema am Element (Vorgabe: Dokument) — nach jedem Themawechsel neu aufrufen. */
export function diagrammThema(wurzel = document.documentElement) {
    const stil = getComputedStyle(wurzel);
    const zusatz = Object.fromEntries(Object.entries(ZUSATZ)
        .map(([schluessel, token]) => [schluessel, stil.getPropertyValue(token).trim()]));
    return { ...echartsThema(wurzel), ...zusatz };
}
/** Hausregel 15.10.2026: dunkler Grund 60 %, weiße Schrift 11 px, ≤ 260 px, confine, keine Verzögerung; richText.
 *  Die Werte stehen wörtlich in me-design/docs/2026-10-11-hausregel-diagramme.md („Der Grund ist in hellem und
 *  dunklem Thema derselbe“) — deshalb feste Werte statt Tokens. `renderMode: "richText"` zeichnet auf der Fläche
 *  (kein innerHTML, P4): Textschatten und Eckenradius stehen dort als Stilwerte, `extraCssText` greift nur, wenn
 *  eine Option auf `renderMode: "html"` zurückschaltet. */
export function hausregelTooltip() {
    return {
        renderMode: "richText", trigger: "item",
        showDelay: 0, hideDelay: 0, transitionDuration: 0, confine: true,
        backgroundColor: "rgba(22,22,23,.6)", borderWidth: 0, borderRadius: 4, padding: [5, 8], shadowBlur: 0,
        textStyle: { color: "#fff", fontSize: 11, textShadowColor: "rgba(0,0,0,.95)", textShadowBlur: 2, textShadowOffsetY: 1 },
        extraCssText: "border-radius:4px;min-width:0;max-width:260px;box-shadow:none;" +
            "text-shadow:0 1px 2px rgba(0,0,0,.95),0 0 2px rgba(0,0,0,.8);",
    };
}
const MUSTER_PX = 8;
/** Je Farbpaar ein Muster: renderItem ruft streifenMuster für jeden Balken (bis 1 500 je Zeichnen) — das Canvas
 *  entsteht nur einmal je Thema. */
const muster = new Map();
/** Schrägstreifen 8×8 aus zwei Tokenfarben als Canvas-Muster für ECharts (`{ image, repeat: "repeat" }`), je
 *  Farbpaar zwischengespeichert. Ohne 2D-Kontext (jsdom) bleibt das Canvas leer. */
export function streifenMuster(vorder, hinter) {
    const schluessel = `${vorder}|${hinter}`;
    const vorhanden = muster.get(schluessel);
    if (vorhanden !== undefined)
        return vorhanden;
    const image = document.createElement("canvas");
    image.width = MUSTER_PX;
    image.height = MUSTER_PX;
    const stift = image.getContext("2d");
    if (stift !== null) {
        stift.fillStyle = hinter;
        stift.fillRect(0, 0, MUSTER_PX, MUSTER_PX);
        stift.strokeStyle = vorder;
        stift.lineWidth = 2;
        stift.beginPath();
        // Die 45°-Linie und ihre beiden Nachbarn über die Ecken: so schließt die Kachel nahtlos an.
        for (const versatz of [-MUSTER_PX, 0, MUSTER_PX]) {
            stift.moveTo(versatz, MUSTER_PX);
            stift.lineTo(versatz + MUSTER_PX, 0);
        }
        stift.stroke();
    }
    const ergebnis = { image, repeat: "repeat" };
    muster.set(schluessel, ergebnis);
    return ergebnis;
}
//# sourceMappingURL=diagrammThema.js.map